// Centralized config for API and image base URLs
export const API_BASE = "https://api.loopyholdings.vip/hotel-frontoffice-api/api/";
export const IMG_BASE = "https://api.loopyholdings.vip/hotel-frontoffice-api/public/";
// If you prefer using environment variables, uncomment below lines:
// export const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.loopyholdings.vip/hotel-frontoffice-api/api/";
// export const IMG_BASE = process.env.REACT_APP_IMG_BASE_URL || "https://api.loopyholdings.vip/hotel-frontoffice-api/public/";